/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Req_3Inputs */

const en_pc_dl_req_3 = /** @type {(inputs: Pc_Dl_Req_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For PdfCraft Online: a current browser with WebGL2, such as Chrome, Edge, Firefox or Safari.`)
};

const zh_pc_dl_req_3 = /** @type {(inputs: Pc_Dl_Req_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 PdfCraft 在线版：需要支持 WebGL2 的新版浏览器，例如 Chrome、Edge、Firefox 或 Safari。`)
};

/**
* | output |
* | --- |
* | "For PdfCraft Online: a current browser with WebGL2, such as Chrome, Edge, Firefox or Safari." |
*
* @param {Pc_Dl_Req_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_req_3 = /** @type {((inputs?: Pc_Dl_Req_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Req_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_req_3(inputs)
	return zh_pc_dl_req_3(inputs)
});
export { pc_dl_req_3 as "pc.dl.req.3" }